import styled from "styled-components";

export const Container = styled.div`
  display: none;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  margin-bottom: 40px;
`;
